module.exports = __webpack_public_path__ + "img/Man-walking-2-1200-COMPRESSED-CROPPED.e426183c.gif";